package com.shadowings.gero.domain.model

import org.jetbrains.compose.resources.StringResource
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

data class MultiPressPair(
    val hieroglyphs: String,
    val meaning: String
)

data class MultiPressContent @OptIn(ExperimentalUuidApi::class) constructor(
    val pairs: List<MultiPressPair>,
    val prompt: QuizText = QuizText.Plain("Abbina ogni geroglifico al significato corretto"),
    override val id: String = Uuid.random().toHexDashString()
) : IQuizContent, ICountableQuiz {
    init {
        require(pairs.size == 4) { "MultiPressContent richiede esattamente 4 coppie" }
    }

    constructor(pairs: List<MultiPressPair>, prompt: StringResource) :
            this(pairs = pairs, prompt = QuizText.Resource(prompt))

    constructor(pairs: List<MultiPressPair>, prompt: String) :
            this(pairs = pairs, prompt = QuizText.Plain(prompt))
}

